import React, { useMemo } from "react";
import BottomKPIBar, {
  KPI
} from "@/components/controls/BottomKPIBar/BottomKPIBar";

interface PartnersKPIData extends Record<string, number> {
  total: number;
}

interface Props {
  totalPartners: number;
  isLoading?: boolean;
  onOpenStateChange?: (isOpen: boolean) => void;
}

const PartnersBottomKPIBar: React.FC<Props> = ({
  totalPartners,
  isLoading = false,
  onOpenStateChange
}) => {
  const kpis: KPI<PartnersKPIData>[] = [{ name: "total" }];

  const data: PartnersKPIData = useMemo(
    () => ({ total: totalPartners }),
    [totalPartners]
  );

  return (
    <BottomKPIBar<PartnersKPIData>
      kpis={kpis}
      data={data}
      pageName="partners"
      isLoading={isLoading}
      onOpenStateChange={onOpenStateChange}
    />
  );
};

export default PartnersBottomKPIBar;
